import { Section } from "./Section";

export interface CatalogSectionFamily {
	SectionFamilyId: number | null;
	SectionFamilyName: string;
	SectionFamilyColor: string;
	IsActive: boolean | null;
	SectionsName?: string;
	SectionsArray: Section[];
}

export const CATALOG_SECTION_FAMILY_INITIAL_VALUES: CatalogSectionFamily = {
	SectionFamilyId: null,
	SectionFamilyName: "",
	SectionFamilyColor: "",
	IsActive: true,
	SectionsName: "",
	SectionsArray: [],
};
